import React, { useEffect, useState } from "react";
import { Printer, QrCode, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { EntitySelect } from "./ui";
import { Header } from "./CorporateDashboard";

export default function TableQR({ ctx, user }) {
  const [tables, setTables] = useState(null);
  const [zone, setZone] = useState("All");
  const origin = window.location.origin;

  useEffect(() => { api.get("/admin/tables").then((r) => setTables(r.data)); }, []);

  if (!tables) return <div className="space-y-6"><Header title="Table QR Codes" /><Loader2 className="animate-spin text-amber-400" /></div>;

  const zones = ["All", ...Array.from(new Set(tables.map((t) => t.zone)))];
  const filtered = zone === "All" ? tables : tables.filter((t) => t.zone === zone);
  const qr = (code) => `https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=8&data=${encodeURIComponent(`${origin}/t/${code}`)}`;

  const controls = (
    <div className="flex items-center gap-3 print:hidden">
      <EntitySelect label="Zone" value={zone} onChange={setZone} testid="qr-zone-select"
        options={zones.map((z) => ({ value: z, label: z }))} />
      <button onClick={() => window.print()} className="gold-btn rounded-lg px-4 py-1.5 text-sm flex items-center gap-2" data-testid="print-qr-btn">
        <Printer size={15} /> Print
      </button>
    </div>
  );

  return (
    <div className="space-y-6">
      <Header title="Table QR Codes" sub={`${filtered.length} tables · scan deep-links straight to the ordering page`} right={controls} />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 print:grid-cols-3 gap-4" data-testid="qr-grid">
        {filtered.map((t) => (
          <div key={t.id} className="qr-card bg-white rounded-2xl p-4 flex flex-col items-center text-center shadow" data-testid={`qr-card-${t.table_code}`}>
            <img src="/omaxe-logo.webp" alt="Omaxe Chowk" className="h-8 w-auto object-contain mb-1" />
            <div className="text-[10px] tracking-widest text-slate-500 font-semibold">{t.foodcourt_name?.toUpperCase()}</div>
            <img src={qr(t.table_code)} alt={`QR ${t.table_code}`} className="w-40 h-40 my-2" />
            <div className="font-display font-extrabold text-2xl text-[#08183A]">Table {t.table_code}</div>
            <div className="text-xs text-slate-600">{t.zone} · {t.seats} seats</div>
            <div className="mt-1 text-[11px] font-bold text-[#1E3A8A]">SCAN TO ORDER</div>
            <div className="mt-1 text-[9px] tracking-[0.15em] text-slate-400">POWERED BY FUNDLE.AI</div>
          </div>
        ))}
      </div>
    </div>
  );
}
